import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { LogIn, Mail } from "lucide-react";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { toast } = useToast();
  const { login } = useApp();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const next = location.state?.next || "/";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast({ title: "Bun venit înapoi!" });
      navigate(next, { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Email sau parolă incorecte.";
      toast({ title: "Eroare la autentificare", description: msg });
    } finally {
      setLoading(false);
    }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[80vh] grid place-items-center px-4 py-10 fade-in">
      <div className="w-full max-w-md amd-card rounded-lg p-6 md:p-8">
        <div className="flex items-center gap-2 mb-1">
          <LogIn className="w-5 h-5" style={{ color: "var(--amd-primary)" }} />
          <span className="text-xs uppercase tracking-wider font-bold" style={{ color: "var(--amd-primary)" }}>Cont utilizator</span>
        </div>
        <h1 className="text-2xl font-black text-white">Conectare</h1>
        <p className="text-sm mt-1" style={{ color: "var(--amd-text-muted)" }}>Intră în contul tău sau alege Google.</p>

        <Button onClick={googleLogin} className="mt-5 w-full h-11 bg-white text-black hover:bg-neutral-100 font-semibold gap-2">
          <GoogleIcon /> Continuă cu Google
        </Button>

        <div className="my-5 flex items-center gap-3">
          <div className="h-px flex-1" style={{ background: "var(--amd-border)" }} />
          <span className="text-xs" style={{ color: "var(--amd-text-muted)" }}>SAU CU EMAIL</span>
          <div className="h-px flex-1" style={{ background: "var(--amd-border)" }} />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Email</Label>
            <div className="relative mt-1.5">
              <Mail className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2" style={{ color: "var(--amd-text-muted)" }} />
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="amd-input h-11 pl-9" placeholder="nume@email.ro" autoFocus required />
            </div>
          </div>
          <div>
            <Label className="text-white text-xs uppercase tracking-wider">Parolă</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="amd-input h-11 mt-1.5" placeholder="••••••••" required />
          </div>
          <Button type="submit" disabled={loading} className="amd-btn-primary w-full h-11 font-semibold">
            {loading ? "Se conectează…" : "Autentificare"}
          </Button>
        </form>

        <p className="mt-5 text-sm text-center" style={{ color: "var(--amd-text-muted)" }}>
          N-ai cont? <Link to="/inregistrare" className="font-semibold amd-link">Înregistrează-te</Link>
        </p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.75h3.57c2.08-1.92 3.28-4.74 3.28-8.07z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.75c-.99.66-2.26 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.52 7.7 23 12 23z"/>
      <path fill="#FBBC05" d="M5.84 14.12A6.99 6.99 0 0 1 5.46 12c0-.74.13-1.45.34-2.12V7.04H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.96l3.66-2.84z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.48 2.18 7.04l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/>
    </svg>
  );
}
